
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

function Pricing() {
    const schedule = [
        { day: "Luni - Vineri", hours: "07:00 - 23:00" },
        { day: "Sambata", hours: "09:00 - 18:00" },
        { day: "Duminica", hours: "09:00 - 18:00" },
    ];

    const fullTimePlans = [
        { name: "Sedinta Fitness", price: "40 Lei" },
        { name: "Sedinta Fitness cu instructor", price: "80 Lei" },
        { name: "Abonament 8 sedinte", price: "160 Lei" },
        { name: "Abonament 12 sedinte", price: "180 Lei" },
        { name: "Abonament nelimitat (30 sedinte)", price: "200 Lei" }, ]

    const specialOffers = [
        {
            name: "1 luna elevi / studenti",
            price: "149 Lei",
            oldPrice: "190 Lei",
        },
        {
            name: "Abonament 2 luni",
            price: "299 Lei",
            oldPrice: "400 Lei",
        },
        {
            name: "Abonament 3 luni",
            price: "399 Lei",
            oldPrice: "540 Lei",
        },
        {
            name: "Abonament 6 luni",
            price: "660 Lei",
            oldPrice: "950 Lei",
        },
        {
            name: "Abonament 12 luni",
            price: "1199 Lei",
            oldPrice: "1600 Lei",
        },
    ];

    return (
        <main className="pricing-page">
            <Helmet>
                <title>Abonamente si program | Cris Gym Fitness</title>
                <meta
                    name="description"
                    content="Vezi programul si preturile de la Cris Gym Fitness. Abonamente accesibile, program clar si oferte limitate pentru antrenamente eficiente."
                />
            </Helmet>

            <section className="pricing-page-hero">
                <div className="pricing-page-container">
                    <p className="pricing-page-label">Abonamente</p>
                    <h1 className="pricing-page-title">Program si preturi</h1>
                    <p className="pricing-page-subtitle">
                        Alege varianta potrivita pentru tine si antreneaza-te intr-un mediu
                        curat, organizat si orientat spre progres real.
                    </p>
                </div>
            </section>

            <section className="pricing-page-schedule">
                <div className="pricing-page-container">
                    <div className="pricing-schedule-card">
                        <h2 className="pricing-section-title">Programul nostru</h2>

                        <div className="pricing-schedule-grid">
                            {schedule.map((item, index) => (
                                <div key={index} className="pricing-schedule-item">
                                    <span>{item.day}</span>
                                    <strong>{item.hours}</strong>
                                </div>
                            ))}
                        </div>

                        <p className="pricing-schedule-note">
                            Va rugam sa respectati orele de antrenament de mai sus.
                        </p>
                    </div>
                </div>
            </section>

            <section className="pricing-page-plans">
                <div className="pricing-page-container">
                    <div className="pricing-plans-grid">

                        {/* ABONAMENTE FULL-TIME */}
                        <div className="pricing-table-card">
                            <h2 className="pricing-section-title">
                                Full-Time (07:00 - 23:00)
                            </h2>

                            <div className="pricing-table-list">
                                {fullTimePlans.map((plan, index) => (
                                    <div key={index} className="pricing-table-row">
                                        <span >{plan.name}</span>
                                        <strong className="normal-pricing">{plan.price}</strong>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* OFERTE LIMITATE */}
                        <div className="pricing-table-card highlighted">
                            <h2 className="pricing-section-title">
                                Oferte Limitate
                            </h2>

                            <div className="pricing-table-list">
                                {specialOffers.map((plan, index) => (
                                    <div key={index} className="pricing-table-row">
                                        <span>{plan.name}</span>

                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "flex-end",
                                                gap: "12px",
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            <del
                                                style={{
                                                    color: "#888",
                                                    fontSize: "13px",
                                                    fontWeight: "400",
                                                }}
                                            >
                                                {plan.oldPrice}
                                            </del>

                                            <strong
                                                style={{
                                                    color: "#b1ff00",
                                                    fontSize: "15px",
                                                    fontWeight: "700",
                                                }}
                                            >
                                                {plan.price}
                                            </strong>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <section className="pricing-page-cta">
                <div className="pricing-page-container">
                    <h2 className="pricing-page-cta-title">
                        Alege abonamentul potrivit si incepe
                    </h2>

                    <p className="pricing-page-cta-text">
                        Contacteaza-ne pentru mai multe detalii sau vino direct la sala.
                    </p>

                    <div className="pricing-page-cta-buttons">
                        <Link to="/contact" className="pricing-page-btn primary">
                            Contacteaza-ne
                        </Link>

                        <Link to="/galerie" className="pricing-page-btn secondary">
                            Vezi sala
                        </Link>
                    </div>
                </div>
            </section>
        </main>
    );
}

export default Pricing;
